/** Mirrored craft-area ids for desktop Story Craft + chat (keep in sync with web craftAreas.ts). */
export const STORY_CRAFT_AREA_IDS = [
  "plotProgression",
  "characterDevelopment",
  "themeReinforcement",
  "pacing",
  "conflictTension",
  "hookEnding",
] as const;

export type StoryCraftAreaId = (typeof STORY_CRAFT_AREA_IDS)[number];

export const CRAFT_AREA_LABELS: Record<StoryCraftAreaId, string> = {
  plotProgression: "Plot Progression",
  characterDevelopment: "Character Development",
  themeReinforcement: "Theme Reinforcement",
  pacing: "Pacing",
  conflictTension: "Conflict/Tension",
  hookEnding: "Hook/Ending",
};
